/**
 * Google Analytics v4
 * see https://redbox.outletcity.com/confluence/display/TUB/Google+Analytics+4+%28GA4%29+E-Commerce+Tracking
 */

import pushDataLayer from "./dataLayer";
import { getGA4Items } from "./analytics4Mappings";
import type { EventName, GA4ItemCollectionPayload, GA4ItemPayload } from "../types/GA4Types.type";
import type { OrderData } from "@ocm/global-types";

export const pushGA4Event = (name: EventName, payload: GA4ItemPayload | GA4ItemCollectionPayload) => {
	const event = {
		event: name,
		ga4_ecommerce: payload,
	};
	pushDataLayer(event, { clearEcommerceObject: true });
};

export const pushGA4CustomEvent = (name: string, payload: Record<string, unknown>) => {
	const event = {
		event: name,
		category: undefined,
		action: undefined,
		label: undefined,
		attributes: undefined,
		type: undefined,
		...payload,
	};
	pushDataLayer(event);
};

export const trackGA4Purchase = ({
	currency,
	orderID,
	orderTotal,
	paymentMethod,
	products,
	shipping,
	type,
	voucher,
	voucherInternalName,
	voucherValue,
}: OrderData) => {
	const payload = {
		items: getGA4Items(products),
		currency,
		value: Number(orderTotal),
		orderType: type === "1" ? "newCustomer" : "existingCustomer", // '1'=Neukunden-Bestellung | '2'=Bestandskunden-Bestellung
		transaction_id: orderID,
		shipping: Number(shipping),
		payment_type: paymentMethod,
		...(voucher && { coupon: voucher }),
		...(voucherInternalName && { couponDescription: voucherInternalName }),
		...(voucherValue && { couponValue: voucherValue }),
	};
	pushGA4Event("purchase", payload);
};
